<template>
  <ContactsImportPreview
    v-if="contacts_import_step == 'file_read'"
    :contacts_import_controller="contacts_import_controller"
    @onClosePreviewImport="onClosePreviewImport">
  </ContactsImportPreview>

  <ContactsImportOptions v-else
    :contacts_import_controller="contacts_import_controller"
    @onFileRead="onFileRead">
  </ContactsImportOptions>
</template>

<script setup>
  import {ref, reactive }         from 'vue';
  import ContactsImportOptions    from './Sections/ContactsImportOptions.vue';
  import ContactsImportPreview    from './Sections/ContactsImportPreview.vue';
  import ContactsImportController from '@/js/Contacts/ContactsImportController';

  const props = defineProps({
    contacts_view: {}
  });

  const contacts_import_controller = reactive(new ContactsImportController());
  const contacts_import_step  = ref("options");

  const onFileRead = () => {
    setContactsImportStep('file_read');
  }

  const onClosePreviewImport = () => {
    setContactsImportStep('options');
    contacts_import_controller.reset();
  }

  const setContactsImportStep = (value) => {
    contacts_import_step.value = value;
  }
</script>